export enum CampaignNameEnum {
    PROFIT_TORO_TRADER = 'lp-profit',
    PROFIT_TORO_TRADER_ADV = 'lp-profit-advfn',
    PROFIT_TORO_TRADER_INVST = 'trd-profit-pro-investing',
    PROFIT_PRO = 'profit-pro',
    PROFIT_PRO_OB = 'profit-pro-outbrain',
    CURSO_DT_INICIANTES = 'infoprodutos-minicurso-daytrade',
    CURSO_DT_INICIANTES_MOBILLS = 'mobills-minicurso-daytrade',
}